import {
    Component,
    Input,
    SimpleChanges,
    Output,
    EventEmitter,
    OnChanges,
    ChangeDetectionStrategy, ChangeDetectorRef,
    HostListener,
    TemplateRef,
    OnInit,
    ContentChild,
    ElementRef
} from '@angular/core';

import {
    trigger,
    state,
    style,
    animate,
    transition,
    keyframes,
    group,
    query,
    stagger,
    animateChild
} from '@angular/animations';

import { LoggerService } from '../../../@core/services/logger-service';

@Component({
    exportAs: 'flipApi',
    selector: 'sk-animated-flip-card',
    styleUrls: ['./animatedFlipCard.scss'],
    templateUrl: './animatedFlipCard.html',
    //changeDetection: ChangeDetectionStrategy.OnPush, // KEEP this off here
    animations: [
        trigger('fadeOuter', [
            state('void', style({
                opacity: 0
            })),
            state('*', style({
                opacity: 1
            })),
            transition('void <=> *', [
                animate('1000ms ease-in-out'),
                query('@flip', [
                    animateChild()
                ])
            ])
        ]),
        trigger('flip', [
            state('front', style({
                transform: 'rotateY(0deg)'
            })),
            state('back', style({
                transform: 'rotateY(-180deg)'
            })),
            transition('front <=> back', [
                animate('1000ms ease-in-out'),
            ])
        ]),
        trigger('fadeInner', [
            state('void', style({
                opacity: 0
            })),
            state('*', style({
                opacity: 1
            })),
            transition('void <=> *', [
                animate('1000ms ease-in-out'),
            ])
        ]),
    ]
})
export class SkAnimatedFlipCardComponent implements OnInit {
    @ContentChild('frontTemplate') frontTemplate: TemplateRef<any>;
    @ContentChild('backTemplate') backTemplate: TemplateRef<any>;

    flipState: string = 'front';
    isFlipping: boolean = false;

    @Input() height: number;
    @Input() width: number;

    _height: string;
    _width: string;

    @Output() flipDone = new EventEmitter<boolean>();
    @Output() flipStart = new EventEmitter<boolean>();

    //@Input() set flip(val: boolean) {
    //    if (val && !this.isFlipping) {
    //        //console.log('forced hc update');
    //        this.toggle();
    //        setTimeout(() => {
    //            this.flipChange.emit(false); // clear the flag after update
    //        }, 250)
    //    }
    //};
    //@Output() flipChange = new EventEmitter<boolean>();

    @HostListener('window: resize')
    resizeWindow(): void {
        //const ref = this.elementRef;
        //const element = this.elementRef.nativeElement;
        const parent = this.elementRef.nativeElement.offsetParent;
        const { offsetHeight, offsetWidth } = parent;
        //this.loggerService.logData(ref);
        //this.loggerService.logData(element);
        this.loggerService.logData(parent);
        this._height = `${this.height ? this.height : offsetHeight}px`;
        this._width = `${this.width ? this.width : offsetWidth}px`;
        //this.loggerService.logMessage(this._height);
        //this.loggerService.logMessage(this._width);
    }

    constructor(
        private elementRef: ElementRef,
        private loggerService: LoggerService,
    ) {
    }
    ngOnInit() {
        setTimeout(() => {
            this.resizeWindow();
        }, 50);
    }
    toggle() {
        this.isFlipping = true;    
        this.flipState = this.flipState === 'front' ? 'back' : 'front';
        //console.log('toggle to', this.flipState);
        //console.log(this.elementRef.nativeElement.parentElement.offsetParent);
    }
    //isContentVisible(flipTarget: string) {
    //    return this.flipState === flipTarget && this.isFlipping === false;
    //}
    onFlipDone() {
        this.isFlipping = false;    
        //console.log('flip is done');
        const isFrontShowing = this.flipState === 'front';
        this.flipDone.emit(isFrontShowing);
    }

    onFlipStart() {
        this.flipStart.emit();
    }
    
}
